/**
 * TODO - create declaration file for CB Components' constants
 * and use that instead of hardcoding hex values here
 */

export default {
  values: {
    Card: {
      headerBackgroundColor: "#15749D",
    },
  },
};
